// Calendar cloud settings base URL
export const CALENDAR_CLOUD_SETTINGS_BASE_URL = '/ows/beta/OutlookCloudSettings/settings/';
